import { IModel, Model } from "@common/models/Model";

export interface IClientCommunicationStatModel extends IModel {
  clientCommunicationStatId: number;
  clientId: number;
  unreadMessageCount: number;
  lastReadCommunicationId: number;
}

export class ClientCommunicationStatModel extends Model implements IClientCommunicationStatModel {
    clientCommunicationStatId: number;
    clientId: number;
    unreadMessageCount: number;
    lastReadCommunicationId: number;

    constructor(params?:Partial<IClientCommunicationStatModel>) {
        super(params);
        this.clientCommunicationStatId = _.defaultTo(params?.clientCommunicationStatId, 0);
        this.clientId = _.defaultTo(params?.clientId, 0);
        this.unreadMessageCount = _.defaultTo(params?.unreadMessageCount, 0);
        this.lastReadCommunicationId = _.defaultTo(params?.lastReadCommunicationId, 0);
    }
}
